import { render, staticRenderFns } from "./return-label-generation.vue?vue&type=template&id=a8a7b7fa&lang=pug"
import script from "./return-label-generation.vue?vue&type=script&lang=ts"
export * from "./return-label-generation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports